import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StaffingProvider } from "@/components/forms/StaffingProvider";
import { ContentProvider } from "@/context/ContentContext";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import TalentSolutions from "@/pages/TalentSolutions";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import SemiconductorSpotlight from "@/pages/SemiconductorSpotlight";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import PortalLogin from "@/pages/PortalLogin";
import PortalVerify from "@/pages/PortalVerify";
import PortalDashboard from "@/pages/PortalDashboard";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StaffingProvider>
          <ContentProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/industries/:slug" element={<IndustryDetail />} />
              <Route path="/talent-solutions" element={<TalentSolutions />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/:slug" element={<SolutionDetail />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/semiconductor" element={<SemiconductorSpotlight />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/careers/:slug" element={<JobDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/portal/login" element={<PortalLogin />} />
              <Route path="/portal/verify" element={<PortalVerify />} />
              <Route path="/portal" element={<PortalDashboard />} />
              <Route path="/privacy" element={<Legal />} />
              <Route path="/terms" element={<Legal />} />
              <Route path="/cookies" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          </ContentProvider>
          <Toaster position="bottom-right" theme="dark" richColors />
        </StaffingProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
